import { render, staticRenderFns } from "./ContactsVue.vue?vue&type=template&id=1c4ae24c&scoped=true"
import script from "./ContactsVue.vue?vue&type=script&lang=js"
export * from "./ContactsVue.vue?vue&type=script&lang=js"
import style0 from "./ContactsVue.vue?vue&type=style&index=0&id=1c4ae24c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4ae24c",
  null
  
)

export default component.exports